<div class="sopo-popup-inner-container">
    <span class="sopo-popup-title">{{ header }}</span>
    <span class="sopo-popup-text">{{body}}</span>
    <form [formGroup]="phoneForm" (ngSubmit)="submitPhone()">
        <ngx-material-intl-tel-input
            [autoIpLookup]="true"
            autoSelectedCountry="us"
            [fieldControl]="phoneControl"
            [required]="true"
            [preferredCountries]="['us']"
            [enablePlaceholder]="true"
            [enableSearch]="true"
            [iconMakeCall]="false"
            [textLabels]="textLabels">
        </ngx-material-intl-tel-input>
    </form>
    <div class="phone-error">
        <span *ngIf="errorInvalid">Your phone number is invalid!</span>
    </div>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button clickable" (click)="submitPhone()">{{okText}}</div>
        <div class="sopo-popup-red-button clickable" *ngIf="cancelText !== ''" (click)="cancel()">{{cancelText}}</div>
    </div>
    <div *ngIf="isInUS" class="verified-legal-language">
        <img class="verified-logo" src="assets/verified/verified_white.webp">
        <span class="legal-language">By entering my phone number, I agree that <span (click)="openLink('https://verified.inc')" style="color: lightblue;">Verified</span> (SoPo’s service provider) and its vendors may receive my personal info and autofill more info about me, including my social security number.</span>
    </div>
</div>
